export default __webpack_public_path__ + "static/media/react.78e61144.png";